import React from "react";
import styled from "styled-components";
import Api from "../classes/Api";
import Translation from "../classes/Translation";
import WebFont from "../classes/WebFont";


const _Textarea = styled.textarea`
    height: ${props => props.height}px;

    background-color: ${props => props.disabled ? "#eceeef" : 
        props.warning ? "#ff9a9a" : 'rgb(255,255,255)'}!important;
    }

    scrollbar-width: auto;
    scrollbar-color: #005E58 #ffffff;  

    &::-webkit-scrollbar {
        width: 16px;
    }

    &::-webkit-scrollbar-track {
        background: #ffffff;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #005E58;
        border-radius: 10px;
        border: 3px solid #ffffff;
    }
`;

export default class Textarea extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            value: this.props.value,
            height: this.props.height,
            warning: false,
            fontGroup: [],
        };

        this.timeout = undefined;
        this.getFontGroup();
    }

    componentDidMount(){
        this.afterOnChange(
            this.props.object._setTextJSON(
                this.state.value,
                Translation.getSelectedLanguage()
            )
        );
    }

    getFontGroup(){
        Api.getFontGroup(this.props.object.getAttr('fontGroup'), (array) => {
            this.setState({
                fontGroup: array
            });
        });
    }

    setGlobalWarningVariable = (warning) => {
        if(warning){
            if(!window.warning.includes(
                this.props.object.getLayer().id()
            )){
                window.warning.push(this.props.object.getLayer().id());
            }
        }else{
            window.warning = window.warning.filter((element) => element != this.props.object.getLayer().id());
        }
    }

    onChange = (event) => {
        this.afterOnChange(
            this.props.object._setTextJSON(
                event.target.value, 
                Translation.getSelectedLanguage()
            )
        );
    }

    onChangeSelect = (event) => {
        let familyName = event.target.value;
        if(familyName){
            WebFont.loadFont({
                familyName: familyName
            }, ()=>{
                this.props.object.fontFamily(familyName);
                this.afterOnChange(
                    this.props.object._setTextJSON(
                        this.state.value,
                        Translation.getSelectedLanguage()
                    ),
                    this.props.onFontChange(this.props.slideIndex)    
                );
            });
        }
    }

    afterOnChange = (warning) => {
        this.setState({
            warning: warning
        });
        this.setGlobalWarningVariable(warning);
        if(this.timeout != undefined)
            clearTimeout(this.timeout);

        this.timeout = setTimeout(()=>{
            this.props.onChange();
        }, 500);
    }

    onFocus = () => {
        this.props.onFocus();
    }

    componentDidUpdate(){
        if(this.state.value != this.props.object._getTextJSON(Translation.getSelectedLanguage())){
            this.setState({
                value: this.props.object._getTextJSON(Translation.getSelectedLanguage())
            });
        }
    }

    render(){
        const { value, height, warning, fontGroup } = this.state;
        const { name } = this.props;
        const _fontGroup = fontGroup.map(element => {
            return(
                <option
                    value={element.name_program}
                    data-local={element.font_type === 'local' ? true : false}
                >
                    { `${Translation.getTranslation("fontText")}: ${element.name}` }
                </option>
            );
        });
        return (
            <>
                <_Textarea
                    className="creator_input form-control"
                    autoComplete="off"
                    autoCorrect="off"
                    spellCheck="false"
                    type="text" 
                    name={name}
                    defaultValue={value}
                    height={height}
                    onChange={this.onChange}
                    onFocus={this.onFocus}
                    disabled={this.props.disabled}
                    warning={warning}
                />
                { _fontGroup.length > 0 && fontGroup != 0 &&
                    <select 
                        className="select_font form-control creator_input"
                        disabled={this.props.disabled}
                        onChange={this.onChangeSelect}
                        defaultValue={this.props.object.fontFamily()}
                    >
                        { _fontGroup }
                    </select>
                }
            </>
        );
    }
}